<div class="modal-wrapper">
  <div class="user-view-modal">
    <button type="button" class="cmn-close" (click)="onClose()"></button>

    <div *ngIf="loading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>Loading user details...</p>
    </div>

    <div *ngIf="error" class="error-state">
      <h3>Error Loading User</h3>
      <p>{{ error }}</p>
      <button class="btn-retry" (click)="loadUserDetails()">Retry</button>
    </div>

    <div *ngIf="!loading && !error && user" class="user-content">
      <div class="user-details-section">
        <div class="user-profile-header">
          <div class="user-avatar">
            <img [src]="user?.profilePic || 'assets/images/profile.jpg'" class="profile-avatar" alt="Profile picture"
              onerror="this.src='assets/images/profile.jpg'" />
            <div class="user-status" [class]="user?.status === 1 ? 'active' : 'inactive'">
            </div>
          </div>

          <div class="user-primary-info">
            <h1 class="user-fullname">
              {{ user?.displayName || '' }} {{ user?.lastName || '' }}
            </h1>
          </div>
        </div>

        <div class="user-info-cards">
          <div class="info-card">
            <div class="card-header">
              <h3 class="card-title">Contact Information</h3>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="info-label">Email</span>
                <span class="info-value">{{ user?.email || 'No email provided' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Phone</span>
                <span class="info-value">{{ user?.phoneNo || 'Not provided' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">OS</span>
                <span class="info-value">{{ user?.os || 'Not available' }}</span>
              </div>
            </div>
          </div>

          <!-- Account Card -->
          <div class="info-card">
            <div class="card-header">
              <h3 class="card-title">Account Details</h3>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="info-label">Subscription</span>
                <span class="subscription-badge" [class]="getSubscriptionClass()">
                  {{ getSubscriptionType() }}
                </span>
              </div>
              <div class="info-row">
                <span class="info-label">Created Date</span>
                <span class="info-value">
                  {{ user?.createdAt}}
                </span>
              </div>
              <div class="info-row">
                <span class="info-label">Newsletter</span>
                <span class="newsletter-status"
                  [class]="user?.isNewsletterSubscribed ? 'subscribed' : 'not-subscribed'">
                  {{ user?.isNewsletterSubscribed ? 'Subscribed' : 'Not Subscribed' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Child Profiles Table -->
      <div class="children-section">
        <div class="section-header">
          <h2 class="section-title">
            Child Profiles
            <span class="count-badge">{{ user?.childProfiles?.length || 0 }}</span>
          </h2>
        </div>

        <div *ngIf="user?.childProfiles?.length; else noChildren" class="children-table-container">
          <table class="children-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Age</th>
                <th>Gender</th>
                <th>PIN</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let child of user.childProfiles">
                <td class="child-name-cell">
                  <div class="child-name-wrapper">
                    <div class="child-avatar-small">
                      <img [src]="child?.avatar || 'assets/images/profile.jpg'" alt="Child"
                        onerror="this.src='assets/images/profile.jpg'" />
                    </div>
                    <div>
                      <div class="child-name">{{ child?.displayName || 'Unnamed' }}</div>
                    </div>
                  </div>
                </td>
                <td>{{ child?.age || '?' }} yrs</td>
                <td>
                  <span class="gender-badge" [ngClass]="formatGenderClass(child?.gender)">
                    {{ child?.gender || '-' }}
                  </span>

                </td>
                <td>{{ child?.secretPin || 'Not set' }}</td>
                <td>
                  <span class="status-indicator" [class]="child?.status === 1 ? 'active' : 'inactive'">
                    {{ child?.status === 1 ? 'Active' : 'Inactive' }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <ng-template #noChildren>
          <div class="empty-state">
            <div class="empty-icon">
              <img [src]="'assets/images/boy.png'" width="50px" height="50px" alt="Child" />
            </div>
            <p>No child profiles added yet</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="dialog-footer">
  <button class="btn btn-secondary" (click)="close()">Close</button>
</div>
